import { BaseModel } from '../../base.model';

export class VerificationOfExperienceResponseDto extends BaseModel {
  emailSent: boolean;
  hrRef: number;
}
